export const ALERT_TYPE = {
  warn: 'warning',
  locked: 'lock',
  alarm: 'alarm',
} as const;
export type AlertType = typeof ALERT_TYPE[keyof typeof ALERT_TYPE];
